import adresses from "./adresses";
import {Form} from "./form";
import selects from "./selects";

let form;

const initForm = (centers) => {
  form = new Form();
  
  window.form = form;
  form.init();
  selects();  
  adresses(centers);  
};

export {form, initForm};
